<template>
  <div v-if="value" class="dialog__wrapper">
    <div class="dialog">
      <div class="dialog_title">
        邮箱验绑
      </div>

      <div class="mobile_tishi" style="margin-top:16px">
        账户绑定的“<span>{{ email }}</span>"邮箱信息异常
      </div>
      <div class="mobile_tishi">
        请重新绑定:
      </div>
      <div :class="['mobileInput',emailClass]">
        <el-input v-model="bindingInfo.email" :clearable="true" placeholder="请输入邮箱" @focus="emailFocus" @blur="emailBlur">
          <template slot="prefix">
            <svg-icon :name="emailIcon" size="24"></svg-icon>
          </template>
        </el-input>
      </div>
      <div>
        <div :class="['codeInput',codeClass]">
          <el-input v-model="bindingInfo.code" :clearable="true" placeholder="请输入验证码" @focus="codeFocus" @blur="codeBlur" ref="codeInput">
            <template slot="prefix">
              <svg-icon :name="codeIcon" size="24"></svg-icon>
            </template>

          </el-input>
          <button class="gainCode" @click="openPt" :style="{background: isSendCode? '#0046b9' : WaitTime < 120? '#dddddd': 'rgba(0,70,185, 0.3)',}">{{ timeIsActive ? "重新获取" + "(" + WaitTime + "S)" : "获取验证码" }}</button>
        </div>
      </div>
      <button class="binding" @click="bidding">
        确认绑定
      </button>
      <validationPT class="setVef" ref="vefCode" @VefCodeTrue="getVefCodeTrue" :inputPhone="bindingInfo.email" theme="dialog"></validationPT>

    </div>
  </div>

</template>
  <script>
import { fetch, post } from "@/ask/axios";
import validationPT from "../../../../Reception/reg/validationPT.vue";
import bus from "@/ask/eventBus";
import { delCookie } from '@/ask/cookiejs.js'

export default {
  components: {
    validationPT
  },
  data() {
    return {
      bindingInfo: {
        emil: "",
        code: ""
      },
      emailIcon: "youxiang-n",//手机号输入框icon
      codeIcon: "yanzhengma-n",//验证码输入框icon
      emailClass: "",//手机输入框类名
      codeClass: "",//验证码输入框类名
      WaitTime: 120,
      isEmailPass: false,
    }
  },
  props: {
    value: {},
    email: {
      type: String
    }
  },
  mounted() {

  },
  computed: {
    timeIsActive() {
      return this.WaitTime < 120 && this.WaitTime > 0;
    },
    isSendCode() {
      if (this.isEmailPass && !(this.WaitTime < 120 && this.WaitTime > 0)) {
        return true
      } else if (!this.bindingInfo.email) {
        return false
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.handleOpen();
      } else {
        this.handleClose();
      }
    },
  },
  methods: {
    //确认绑定
    bidding() {
      if (!this.bindingInfo.email && this.bindingInfo.code) {
        this.$message.error('请输入邮箱')
        this.mobileClass = "borderRed"
        this.isMobilePass = false
        this.mobileIcon = "youxiang-r"
        return
      } else if (!this.bindingInfo.code && this.bindingInfo.email) {
        this.$message.error('请输入验证码')
        this.codeClass = "borderRed"
        this.codeIcon = "yanzhengma-r"
        return
      } else if (!this.bindingInfo.code && !this.bindingInfo.email) {
        this.$message.error('请输入邮箱和验证码')
        this.codeClass = "borderRed"
        this.codeIcon = "yanzhengma-r"
        this.mobileClass = "borderRed"
        this.isMobilePass = false
        this.mobileIcon = "youxiang-r"
        return
      }
      let url = this.$api04 + 'Basics/api/Authentication/UpdateMail';

      const params = {
        mail: this.bindingInfo.email,
        mailCode: this.bindingInfo.code
      };
      post(url, params).then((res) => {
        console.log("确认绑定", res);
        if (res.IsOK) {
          this.handleClose()
        } else {
          this.$message.error(res.Message)
        }
      })
    },
    //获取验证码
    openPt() {
      if (!this.isSendCode || this.timeIsActive) {
        return;
      }
      this.$refs.vefCode.GetSlideBlockApi(); //获取图片
      this.$refs.vefCode.clkOpenRef(); //打开框
      this.$refs["codeInput"].focus();
      this.isEmailPass = false

    },
    // 拼图验证正确回调
    getVefCodeTrue({ MarkCode, LstMouseTrack }) {
      this.pTparams = {
        MarkCode: MarkCode,
        LstMouseTrack: LstMouseTrack,
        Email: this.bindingInfo.email,

      };
      let url = this.$api02 + "/api/EbayCustomer/CustomerInfo/NewUpdateEmailSendEmail"
      post(url, this.pTparams).then((res) => {
        console.log("Code", res);
        if (res.IsOK) {

        }
      })
      let timer = null;
      if (!timer) {
        timer = setInterval(() => {
          if (this.WaitTime > 0) {
            this.WaitTime--;
          } else {
            clearInterval(timer);
            timer = null;
            this.WaitTime = 120;
          }
        }, 1000);
      }
    },
    //邮箱输入框聚焦
    emailFocus() {
      this.emailClass = "borderBlue"
      this.emailIcon = "a-youxiang-r2"
    },
    // 邮箱输入框失焦
    emailBlur() {
      let regs = /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/;
      if (this.bindingInfo.email) {
        if (regs.test(this.bindingInfo.email)) {
          // let url = this.$api02 + "/api/EbayCustomer/CustomerRegist/RegistVerify";
          let url = this.$api04+"Basics/api/CustomerRegist/RegistVerify";
          let param = {};
          param.Email = this.bindingInfo.email;
          post(url, param).then((res) => {
            if (res.IsOK) {
              this.emailClass = ""
              this.emailIcon = "youxiang-n"
              this.isEmailPass = true
            } else {
              this.emailClass = "borderRed"
              this.emailIcon = "youxiang-r"
              this.$message.error("邮箱已被绑定使用")
              this.isEmailPass = false
            }
          })
        } else {
          this.emailClass = "borderRed"
          this.emailIcon = "youxiang-r"
          this.$message.error("邮箱格式不正确")
          this.isEmailPass = false
        }
      } else {
        this.emailClass = "borderRed"
        this.emailIcon = "youxiang-r"
        this.$message.error("请输入邮箱")
        this.isEmailPass = false
      }
    },
    codeFocus() {
      this.codeClass = "borderBlue"
      this.codeIcon = "yanzhengma-b"
    },
    codeBlur() {
      if (this.bindingInfo.code) {
        this.codeClass = ""
        this.codeIcon = "yanzhengma-n"
      } else {
        this.codeClass = "borderRed"
        this.codeIcon = "yanzhengma-r"
        this.$message.error("请输入验证码")
      }
    },
    handleOpen() {
      this.$emit("open");
    },
    // 关闭弹框
    handleClose() {
      this.$emit("close", false);
      this.$emit("input", false);
      delCookie("CustomerInfo")
      localStorage.removeItem("loginMessage")
      localStorage.removeItem("SalesInfos")
    }
  },


}
  </script>
  <style lang="scss" scoped>
.dialog__wrapper {
  z-index: 10000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.24);
}
.dialog {
  position: absolute;
  border-radius: 4px;
  width: 400px !important;
  top: 50%;
  margin-top: -200px;
  height: 316px;
  left: 50%;
  margin-left: -158px;
  background: #ffffff;
}
.dialog_title {
  height: 56px;
  border-bottom: solid 1px #f0f0f0;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 56px;
  padding-left: 24px;
  box-sizing: border-box;
}

.mobile_tishi {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  height: 20px;
  line-height: 20px;
  padding-left: 24px;
  box-sizing: border-box;
  margin-bottom: 8px;
  span {
    color: #d83f3f;
  }
}
.mobileInput {
  width: 352px !important;
  height: 40px !important;
  border-radius: 4px;
  border: 1px solid #dddddd;
  line-height: 38px !important;
  margin: 0 24px 16px;
  transition: border 0.2s;
  &:hover {
    border: 1px solid #aaaaaa;
    transition: border 0.2s;
  }
}
.codeInput {
  width: 224px !important;
  height: 40px !important;
  border-radius: 4px;
  border: 1px solid #dddddd;
  line-height: 38px !important;
  margin: 0 24px 16px;
  transition: border 0.2s;
  &:hover {
    border: 1px solid #aaaaaa;
    transition: border 0.2s;
  }
}
/deep/.el-input {
  height: 40px !important;
}
/deep/ .el-input__inner {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  height: 40px !important;
  line-height: 40px !important;
  color: #333333;
  border: none;
  padding-left: 36px !important;
}
/deep/ .el-input__suffix {
  line-height: 40px !important;
  height: 40px;
  display: flex;
  align-items: center;
}
/deep/ .svgicon {
  position: relative;
  top: 3px;
  left: 2px;
}
.borderBlue {
  border: solid 1px #0046b9 !important;
  transition: all 0.2s;
}
.borderRed {
  border: 1px solid #d83f3f !important;
  transition: all 0.2s;
  ::placeholder {
    color: #d83f3f !important;
  }
}
.binding {
  width: 224px !important;
  height: 40px !important;
  background: #0046b9;
  border-radius: 20px;
  margin: 8px 88px 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    background: #2963c4;
    transition: all 0.2s;
  }
  &:active {
    background: #003a9b;
    transition: all 0.2s;
  }
}
.gainCode {
  width: 120px;
  height: 40px;
  background: #0046b9 rgba(255, 255, 255, 0.64);
  border-radius: 4px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  outline: none;
  cursor: pointer;
  margin-left: 28px;
  position: absolute;
  border: none;
  right: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/home/public/bindingDialog/emailDialog.vue